<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section *ngIf="!!provider">
      <!--PROVIDER_DETAIL-->
      <div class="row mb-1" *ngIf="!!providerId">
        <div class="col-12 d-flex justify-content-end">
          <a type="button" class="btn btn-primary" [routerLink]="'/dashboard/providers/edit/' + providerId">{{ "EDIT" | translate }}</a>
        </div>
      </div>
      <div class="row">
        <div class="col-12" [ngClass]="(!!provider.addresses && provider.addresses.length > 0) || (!!provider.referents && provider.referents.length > 0) ? 'col-lg-6 ' : ''">
          <div class="card">
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-12 mb-1" id="provider-profile">
                  <div id="logo">
                    <img
                      ngClass.sm="mb-075"
                      ngClass.md="mb-075"
                      #image
                      (load)="image.hidden = false"
                      (error)="image.hidden = true"
                      class="rounded contain"
                      [src]="provider.logo"
                      [alt]="'{{provider.name}}'"
                      width="100"
                      height="100"
                    />
                    <div ngClass.sm="mb-075" ngClass.md="mb-075" id="fake-avatar" class="rounded" *ngIf="image.hidden">
                      <span>{{ provider.name | initials }}</span>
                    </div>
                  </div>
                  <div>
                    <h3 class="mb-0">{{ provider.name }}</h3>
                    <p class="mb-0 font-small-3 text-muted">{{ provider.business_name }}</p>
                  </div>
                </div>
                <div class="col-12 mb-1">
                  <div class="row">
                    <div class="col mb-md-1" *ngIf="!!provider.vat_number">
                      <div class="font-weight-bold font-medium-1">{{ "VAT_NUMBER" | translate }}:</div>
                      <div>{{ provider.vat_number }}</div>
                    </div>
                    <div class="col mb-lg-1" *ngIf="!!provider.fiscalcode">
                      <div class="font-weight-bold font-medium-1">{{ "FISCAL_CODE" | translate }}:</div>
                      <div>{{ provider.fiscalcode }}</div>
                    </div>
                    <div class="col" *ngIf="!!provider.unique_code">
                      <div class="font-weight-bold font-medium-1">{{ "UNIQUE_CODE" | translate }}:</div>
                      <div>{{ provider.unique_code }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!provider.bank_name">
                  <div class="font-weight-bold font-medium-1">{{ "BANK" | translate }}:</div>
                  <div>{{ provider.bank_name }}</div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!provider.invoice_type_name">
                  <div class="font-weight-bold font-medium-1">{{ "INVOICE_TYPE" | translate }}:</div>
                  <div>{{ provider.invoice_type_name }}</div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!provider.pec">
                  <div class="font-weight-bold font-medium-1">{{ "PEC" | translate }}:</div>
                  <div>{{ provider.pec }}</div>
                </div>
                <div class="col-md-6 col-12 mb-1" *ngIf="!!provider.recipient_pec">
                  <div class="font-weight-bold font-medium-1">{{ "RECIPIENT_PEC" | translate }}:</div>
                  <div>{{ provider.recipient_pec }}</div>
                </div>
                <div class="col-md-6 col-12 mb-2" *ngIf="!!provider.email">
                  <div class="font-weight-bold font-medium-1">{{ "EMAIL" | translate }}:</div>
                  <div>{{ provider.email }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" ngClass.sm="col-12" ngClass.md="col-12" *ngIf="provider && ((!!provider.addresses && provider.addresses.length > 0) || (!!provider.referents && provider.referents.length > 0))">
          <div class="card" *ngIf="provider && !!provider.addresses && provider.addresses.length > 0">
            <div class="card-body">
              <div class="row">
                <div class="col-12 d-flex align-items-center">
                  <h3 class="mb-05"><i class="text-primary mr-05" data-feather="map" size="20"></i> {{ "MENU.CUSTOMERS_LOCATION" | translate }}</h3>
                </div>
              </div>
              <div class="row" *ngIf="provider && provider.addresses.length > 0">
                <div class="col-12">
                  <ul class="list-unstyled mt-1 px-2 ml-075 font-medium-1">
                    <li *ngFor="let address of provider.addresses; let i = index" [ngClass]="i < provider.addresses.length - 1 ? 'border-bottom pb-05 mb-05' : ''">
                      <strong>{{ address.label | titlecase }}</strong> <br />
                      <span>{{ address.street | titlecase }} {{ address.zipcode }} {{ address.city_name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="card" *ngIf="provider && !!provider.referents && provider.referents.length > 0">
            <div class="card-body row">
              <div class="col-12 d-flex align-items-center">
                <h3 class="mb-05"><i class="text-info mr-05" data-feather="user" size="20"></i> {{ "REFERENT" | translate }}</h3>
              </div>
              <div class="col-12">
                <ul class="list-unstyled mt-1 px-2 ml-075 font-medium-1">
                  <li *ngFor="let referent of provider.referents; let i = index" [ngClass]="i < provider.referents.length - 1 ? 'border-bottom pb-05 mb-05' : ''">
                    <strong>{{ referent.firstname | titlecase }} {{ referent.lastname | titlecase }}</strong> <br />
                    <a class="mr-1" href="mailto:{{ referent.email }}"> <i size="15" [data-feather]="'mail'"></i> {{ referent.email }} </a>
                    <a class="text-success" href="tel:{{ referent.phone }}"> <i size="15" [data-feather]="'phone'"></i> {{ referent.phone }} </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--COMMISSIONS-->
      <div class="row" *ngIf="_authenticationService.hasCapability('show_menu_commission')">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-0 pb-0">
              <div class="px-2 pb-2 d-flex align-items-center justify-content-between">
                <h3 class="mb-0"><i class="text-primary mb-025" data-feather="briefcase" size="20"></i> {{ "COSTS" | translate }}</h3>
                <div>
                  <label for="monthYear" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
                    <select [(ngModel)]="selectedMonth" (ngModelChange)="loadProvider()" id="monthYear" class="form-control pr-3 text-capitalize">
                      <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                      <option value="0">{{ "ALL" | translate }}</option>
                      <option *ngFor="let month of availableMonths" [value]="month" [label]="formatMonth(month)">{{ month }}</option>
                    </select>
                  </label>
                  <label for="years" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
                    <select id="years" [(ngModel)]="selectedYear" (change)="loadProvider()" class="form-control pr-3">
                      <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                    </select>
                  </label>
                </div>
              </div>
              <ngx-datatable
                class="bootstrap core-bootstrap"
                columnMode="force"
                [headerHeight]="30"
                [scrollbarH]="true"
                [rowHeight]="_utilService.isDesktop ? 90 : 150"
                [limit]="10"
                [footerHeight]="50"
                [rows]="filteredProviderCost"
                [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
              >
                <ngx-datatable-column [name]="'AMOUNT' | translate" prop="amount" *ngIf="_utilService.isDesktop">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ _utilService.addDotsToNumber(row.amount) }} €</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'MONTH' | translate" prop="month" *ngIf="_utilService.isDesktop">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ formatMonth(row.month) | titlecase }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'YEAR' | translate" prop="year" *ngIf="_utilService.isDesktop">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.year }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'COMMISSION' | translate" prop="commission.complete_name" *ngIf="_utilService.isDesktop">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <div class="d-flex align-items-center">
                      <a *ngIf="row.commission.id" [routerLink]="'/dashboard/commission/edit/' + row.commission.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.commission.complete_name }}</a>
                      <span *ngIf="!row.commission.id">-</span>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!--mobile - tablet-->
                <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <div class="col-12 list-item-mobile pl-0">
                      <div>
                        <span class="font-weight-bold">{{ "AMOUNT" | translate }}: </span>
                        <span>{{ _utilService.addDotsToNumber(row.amount) }} €</span>
                      </div>
                      <div>
                        <span class="font-weight-bold">{{ "MONTH" | translate }}: </span>
                        <span>{{ formatMonth(row.month) | titlecase }}</span>
                      </div>
                      <div>
                        <span class="font-weight-bold">{{ "YEAR" | translate }}: </span>
                        <span>{{ row.year }}</span>
                      </div>
                      <div>
                        <span class="font-weight-bold">{{ "COMMISSION" | translate }}: </span>
                        <a *ngIf="row.commission.id" [routerLink]="'/dashboard/commission/edit/' + row.commission.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.commission.complete_name }}</a>
                        <span *ngIf="!row.commission.id">-</span>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <div class="p-1">{{ "TOTAL_COSTS" | translate }}: {{ _utilService.addDotsToNumber(totalCost) }}€</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
